import { useState, useCallback } from "react";
import Layout from "./components/Layout";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import WhatIDo from "./components/WhatIDo";
import DiscoverySprint from "./components/DiscoverySprint";
import BuildAndLaunch from "./components/BuildAndLaunch";
import AISystems from "./components/AISystems";
import MyPOV from "./components/MyPOV";
import MeetTheOperator from "./components/MeetTheOperator";
import ProofAndPatterns from "./components/ProofAndPatterns";
import Testimonials from "./components/Testimonials";
import WhoIWorkWith from "./components/WhoIWorkWith";
import ContactDialog from "./components/ContactDialog";
import Footer from "./components/Footer";
import { trackCtaClick, trackFormOpen } from "./lib/analytics";

export default function App() {
  const [contactOpen, setContactOpen] = useState(false);

  const openContact = useCallback((location: string) => {
    trackCtaClick(location);
    trackFormOpen();
    setContactOpen(true);
  }, []);

  return (
    <Layout>
      <Nav onContactOpen={() => openContact("nav")} />
      <main>
        <Hero onContactOpen={() => openContact("hero")} />
        <WhatIDo />
        <DiscoverySprint />
        <BuildAndLaunch />
        <AISystems />
        <MyPOV />
        <MeetTheOperator />
        <ProofAndPatterns />
        <Testimonials />
        <WhoIWorkWith />
      </main>
      <Footer />
      <ContactDialog open={contactOpen} onOpenChange={setContactOpen} />
    </Layout>
  );
}
